import RiotEventManager   from 'utilities/riot/event_manager';
import { PlannerBase } from '../../planner_base';

export default class PlannerControllerBase extends PlannerBase {
  eventManager: RiotEventManager;
  constructor(tag){
    super();
    this.eventManager = new RiotEventManager(tag)
  }
  customEvent(event_name: string, callback: (e) => void){
    this.eventManager.customEvent(event_name, callback);
  }
  reduxEvent(scope: string, callback:(newVal, oldVal, objectPath) => void){
    this.eventManager.reduxEvent(scope, callback);
  }
  updateData(newVal){
    App.store.dispatch(App.actions.data.update(newVal));
  }
  updatePlanner(newVal){
    App.store.dispatch(App.actions.planner.update(newVal));
  }
  updateLines(newVal){
    App.store.dispatch(App.actions.planner.lines(newVal));
  }
  updateTasks(newVal){
    App.store.dispatch(App.actions.planner.tasks(newVal));
  }
  updateMemos(newVal){
    App.store.dispatch(App.actions.planner.memos(newVal));
  }
  updateTaskables(newVal){
    App.store.dispatch(App.actions.planner.taskable(newVal));
  }
  updateLocations(newVal){
    App.store.dispatch(App.actions.planner.locations(newVal));
  }
  updateSchedules(newVal){
    App.store.dispatch(App.actions.planner.schedules(newVal));
  }
  updateOrders(newVal){
    App.store.dispatch(App.actions.planner.orders(newVal));
  }
}
